// Shared constants for the Birthday Event Reservation system.

// Each time slot maps to a party concept (bilingual label via i18n key).
export const TIME_SLOTS = [
  { value: "10:00 - 12:00", concept: "conceptBreakfast" },
  { value: "16:00 - 18:00", concept: "conceptTea" },
  { value: "17:00 - 19:00", concept: "conceptTea" },
];

export const slotConceptKey = (value) =>
  (TIME_SLOTS.find((s) => s.value === value) || {}).concept || null;

// "16:00 - 18:00 · Birthday Tea Party"  (t = translator)
export const slotLabel = (value, t) => {
  if (!value) return "";
  const key = slotConceptKey(value);
  return key ? `${value} · ${t(key)}` : value;
};

export const EVENT_STATUSES = ["new", "offer_sent", "confirmed", "completed", "cancelled"];

export const STATUS_LABELS = {
  new: "statusNew",
  offer_sent: "statusOfferSent",
  confirmed: "statusConfirmed",
  completed: "statusCompleted",
  cancelled: "statusCancelled",
};

export const STATUS_STYLES = {
  new: "bg-[#EA672D]/15 text-[#EA672D]",
  offer_sent: "bg-[#C99A2E]/20 text-[#8a6a14]",
  confirmed: "bg-[#26422A]/15 text-[#26422A]",
  completed: "bg-[#2F6B4F]/15 text-[#2F6B4F]",
  cancelled: "bg-[#5D372A]/15 text-[#5D372A]",
};

// Build a wa.me link from a (possibly local) phone number.
export const waLink = (phone) => {
  const digits = (phone || "").replace(/\D/g, "");
  const intl = digits.startsWith("0") ? "9" + digits : digits.startsWith("90") ? digits : "90" + digits;
  return `https://wa.me/${intl}`;
};

// Build a wa.me link from a stored phone that may already be E.164 (+<cc>...).
// Numbers with a leading "+" already carry their country code and are used as-is.
// Legacy local Turkish values (0xxx / bare) are normalised to +90 without duplicating it.
export const waLinkE164 = (phone) => {
  const raw = (phone || "").trim();
  let digits;
  if (raw.startsWith("+")) {
    digits = raw.replace(/\D/g, "");
  } else {
    const d = raw.replace(/\D/g, "");
    digits = d.startsWith("90") ? d : d.startsWith("0") ? "9" + d : "90" + d;
  }
  return `https://wa.me/${digits}`;
};
